'use client'

import BusinessSolutionPage from '@/components/platform/v2/BusinessSolutionPage'
import { PhoneMock, MockRow } from '@/components/platform/v2/Mocks'
import { getSolution } from '@/data/solutions'

const EducationSolution = () => (
    <BusinessSolutionPage
        config={{
            meta: getSolution('education'),
            eyebrow: 'Образование, эксперты и подписочные продукты',
            titleLines: ['Не просто выдать доступ к материалам.', 'Построить отношения с учеником'],
            lead: 'Продажи, обучение, личный кабинет, контент, коммуникации, задания, подписки и повторные продукты в одном контуре.',
            problems: [
                { title: 'Курс продаётся в одном сервисе' },
                { title: 'Материалы лежат в другом' },
                { title: 'Общение происходит в мессенджерах' },
                { title: 'CRM существует отдельно' },
                { title: 'После курса ученик снова становится холодным лидом' },
            ],
            flowTitle: 'Путь ученика целиком',
            flow: [
                'Реклама / эксперт / сайт',
                'Заявка',
                'Оплата',
                'Личный кабинет',
                'Материалы / курс',
                'Задание / тест',
                'Результат',
                'Коммуникация',
                'Следующий продукт',
            ],
            visual: (
                <PhoneMock title="Личный кабинет ученика">
                    <MockRow label="Курс" value="64%" accent />
                    <MockRow label="Материалы" value="доступны" />
                    <MockRow label="Задание" value="выполнить" accent />
                    <MockRow label="Результат" value="сохранён" />
                    <MockRow label="Следующий продукт" value="подобран" />
                </PhoneMock>
            ),
            featuresTitle: 'Возможности',
            features: [
                'Продажа курсов и доступов',
                'Подписочная модель',
                'Личный кабинет',
                'Контент',
                'Тесты / квизы',
                'Сертификаты',
                'Чаты и коммуникации',
                'CRM учеников',
                'Оплаты',
                'AI-сценарии',
                'Реферальная система',
            ].map((title) => ({ title })),
            audience: ['Онлайн-школы', 'Эксперты', 'Корпоративное обучение', 'Клубы', 'Подписочные сообщества', 'Образовательные проекты'],
        }}
    />
)

export default EducationSolution
